import { render } from "./ui-dialogbox.vue?vue&type=template&id=ca953840"
import script from "./ui-dialogbox.vue?vue&type=script&lang=js"
export * from "./ui-dialogbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__